import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const SendIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            // eslint-disable-next-line max-len
            d='M3 17.936C3 19.3718 4.4681 20.3399 5.78784 19.7743L19.7107 13.8074C21.3269 13.1147 21.3269 10.8234 19.7107 10.1308L5.78784 4.16386C4.4681 3.59826 3 4.56632 3 6.00215V8.6822C3 9.42255 3.54017 10.0522 4.27191 10.1648L16 11.9691L4.27191 13.7734C3.54017 13.886 3 14.5156 3 15.256V17.936Z'
            fill='currentColor'
        />
    </svg>
));
